import React from 'react';

type JsonLdProps = {
  id: string;
  data: Record<string, unknown>;
};

const JsonLd = ({ id, data }: JsonLdProps) => {
  const serializeJsonLd = (data: JsonLdProps['data']) => {
    return JSON.stringify(data)
      .replace(/</g, '\\u003c')
      .replace(/>/g, '\\u003e')
      .replace(/&/g, '\\u0026');
  };

  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
    />
  );
};

export default JsonLd;
